import { PUT, POST } from '@/api/api'
import { UsersFormData } from '@/types/usersFormData'

export const useSaveUser = () => {
  const save = async (formData: UsersFormData, id?: string) => {
    const url = id ? `/api/users/${id}` : '/api/users'
    const method = id ? PUT : POST

    return method(url, formData)
  }

  return { save }
}
